import { render, staticRenderFns } from "./BarSet.vue?vue&type=template&id=552a0e8b&functional=true&"
import script from "./BarSet.vue?vue&type=script&lang=js&"
export * from "./BarSet.vue?vue&type=script&lang=js&"
import style0 from "./BarSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports